module.exports = __webpack_public_path__ + "img/hero_portrait_witch-doctor_female.6806bab7.png";